import { render, staticRenderFns } from "./create-collect-point-rank.vue?vue&type=template&id=c8ab20a4&scoped=true"
import script from "./create-collect-point-rank.vue?vue&type=script&lang=js"
export * from "./create-collect-point-rank.vue?vue&type=script&lang=js"
import style0 from "./create-collect-point-rank.vue?vue&type=style&index=0&id=c8ab20a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ab20a4",
  null
  
)

export default component.exports